import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const LogbookIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faBook} color="#6CBB69" />;
};
